import { CircularProgress, Stack, Typography } from '@mui/material';
import React from 'react';

export function SearchResultsLoader() {
  return (
    <Stack
      flexGrow={1}
      alignItems="center"
      justifyContent="center"
      gap={2}
      direction="row"
      py={8}
    >
      <CircularProgress size={24} />
      <Typography mt={0.5} lineHeight={1} variant="h6">
        Searching...
      </Typography>
    </Stack>
  );
}
